import React, { useState, useEffect, useReducer } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import IconButton from '@mui/material/IconButton'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TextField from '@mui/material/TextField'
import { EMPTY_OBJECT } from './AddTaskList'

function MeasureDefinition(props) {
    const [sqLDbList, setSqLDbList] = useState([])
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSources, setDataSources] = useState([])
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [dimensions, setDimensions] = useState([])
    const [measures, setMeasures] = useState([])

    // UI State Variables
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [editFormula, setEditFormula] = useState(false)
    const [popupFormula, setPopupFormula] = useState('')
    const [popupSelectedMeasure, setPopupSelectedMeasure] = useState('')
    const [, forceUpdate] = useReducer(x => x + 1, 0)

    //#region useEffect
    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            callForPropDataToLoadExisting()
        } else {
            resetStateData()
        }
    }, [])
    useEffect(() => {
        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            callForPropDataToLoadExisting()
        } else {
            resetStateData()
        }
    }, [props.taskData.databaseId])
    //#endregion

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dsSystemName - Data source system name from the selected database
     */
    function fireOnSaveEvent(dbId, dsSystemName, measureChanges) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["dataSourceSystemName"] = dsSystemName
            copied["measureChanges"] = measureChanges
            props.onSave(copied)
        }
    }

    //#region State Set Methods
    function resetStateData() {
        setDatabaseId(-1)
        setDataSources([])
        setDataSourceSystemName('')
        setDimensions([])
        setMeasures([])
        setIsLoadingRequest(false)
        setEditFormula(false)
        setPopupFormula('')
        setPopupSelectedMeasure('')
    }
    function callForPropDataToLoadExisting() {
        setDatabaseId(props.taskData.databaseId)
        setIsLoadingRequest(true)

        let getDataSources = props.getDataSources(props.taskData.databaseId)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setDataSources(json)
            setDataSourceSystemName(props.taskData.dataSourceSystemName)
            setDimensions([])
            setEditFormula(false)
            setMeasures([])
            setPopupFormula('')
            setPopupSelectedMeasure('')

            let getDimensions = props.getDimensions(props.taskData.databaseId, props.taskData.dataSourceSystemName)
            let getMeasureAggregations = props.getMeasureAggregations(props.taskData.databaseId, props.taskData.dataSourceSystemName)

            getDimensions.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                let dimensionsFromDataSource = json.filter(x => x.typeOfDimension !== -1)
                
                setDimensions(dimensionsFromDataSource)
                fireOnSaveEvent(props.taskData.databaseId, props.taskData.dataSourceSystemName, [])

                if (props.taskData.measureChanges && props.taskData.measureChanges.length > 0) {
                    setIsLoadingRequest(false)
                    setMeasures(props.taskData.measureChanges)
                } else {
                    getMeasureAggregations.then((resp2) => { 
                        if (resp2.status !== 200) {
                            throw new Error(resp2)
                        } else {
                            return resp2.json()
                        }
                    }).then((json2) => {
                        setMeasures(json2)
                        setIsLoadingRequest(false)
                    }).catch((ex) => {
                        console.error(ex)
                    })
                }
            }).catch((ex) => {
                console.error(ex)
                resetStateData()
            })
        }).catch((ex) => {
            console.error(ex)
            resetStateData()
        })
    }
    //#endregion

    //#region Handlers Events
    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setIsLoadingRequest(true)
        setDataSources([])
        setDataSourceSystemName('')
        setDimensions([])
        setMeasures([])
        setEditFormula(false)
        setPopupFormula('')
        setPopupSelectedMeasure('')

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setDataSources(json)
            setIsLoadingRequest(false)
            setDimensions([])
            setMeasures([])
            setEditFormula(false)
            setPopupFormula('')
            setPopupSelectedMeasure('')
            fireOnSaveEvent(event.target.value, '', [])
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setDimensions([])
            setMeasures([])
            setDataSourceSystemName('')
            setIsLoadingRequest(false)
            setEditFormula(false)
            setPopupFormula('')
            setPopupSelectedMeasure('')
        })
    }
    function handleDataSourceChange(event) {
        event.preventDefault()
        setDataSourceSystemName(event.target.value)
        setIsLoadingRequest(true)

        let getDimensions = props.getDimensions(databaseId, event.target.value)
        let getMeasureAggregations = props.getMeasureAggregations(databaseId, event.target.value)

        getDimensions.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let dimensionsFromDataSource = json.filter(x => x.typeOfDimension !== -1)
            
            setDimensions(dimensionsFromDataSource)
            fireOnSaveEvent(databaseId, event.target.value, [])

            getMeasureAggregations.then((resp2) => { 
                if (resp2.status !== 200) {
                    throw new Error(resp2)
                } else {
                    return resp2.json()
                }
            }).then((json2) => {
                setMeasures(json2)
                setIsLoadingRequest(false)
            }).catch((ex) => {
                console.error(ex)
            })
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setDataSourceSystemName('')
            setIsLoadingRequest(false)
            setDimensions([])
            setMeasures([])
            setEditFormula(false)
            setPopupFormula('')
            setPopupSelectedMeasure('')
        })
    }
    function handleChangeMultiple(event) {
        const { options } = event.target
        const value = []
        for (let i = 0, l = options.length; i < l; i += 1) {
            if (options[i].selected) {
                value.push(options[i].value)
            }
        }
        
        if (value.length > 0) {
            let copied = popupFormula
            copied = copied + "[" + value[0] + "]"
            setPopupFormula(copied)
        }
      }
    //#endregion

    //#region Render Methods
    function renderMeasureDefinitionTable(dimensionData, measuresData, editMode, dbId, dbSystemName) {
        let dimensionTableHeaders = []
        let tableBodyRows = []

        // Table Headers
        for (let dimItr = 0; dimItr < dimensionData.length; dimItr++) {
            dimensionTableHeaders.push(<TableCell key={`dimension-header-${dimensionData[dimItr]["systemName"]}`}>{dimensionData[dimItr]["alias"]}</TableCell>)
        }

        for (let measureItr = 0; measureItr < measuresData.length; measureItr++) {
            let currentMeasure = measuresData[measureItr]
            let dimensionAggregationDropDowns = []
            let weightedAverageMenuItems = []

            for (let measureItr2 = 0; measureItr2 < measuresData.length; measureItr2++) {
                let currentMeasure2 = measuresData[measureItr2]
                if (currentMeasure2["systemName"] !== currentMeasure["systemName"]) {
                    weightedAverageMenuItems.push(<MenuItem key={`dimension-aggregation-${currentMeasure2["systemName"]}-weighted-average`} value={currentMeasure2["measureName"]}>
                        Weighted Average: {stringIsEmpty(currentMeasure2["measureName"]) ? currentMeasure2["aliasName"] : currentMeasure2["measureName"]}
                    </MenuItem>)
                }
            }

            for (let dimItr = 0; dimItr < dimensionData.length; dimItr++) {
                let currentDimension = dimensionData[dimItr]
                dimensionAggregationDropDowns.push(<TableCell key={`dimension-aggregation-${currentMeasure["systemName"]}-${dimensionData[dimItr]["systemName"]}`}>
                    <Select
                        id={`dimension-aggregation-${currentMeasure["systemName"]}-${dimensionData[dimItr]["systemName"]}-dropdown`}
                        key={`dimension-aggregation-${currentMeasure["systemName"]}-${dimensionData[dimItr]["systemName"]}-dropdown`}
                        onChange={(e) => {
                            e.preventDefault()
                            
                            let copied = JSON.parse(JSON.stringify(measuresData))

                            if (typeof e.target.value  === 'string') {
                                copied[measureItr]["dimensionAggregations"][dimItr]["calcType"] = 6
                                copied[measureItr]["dimensionAggregations"][dimItr]["calcParameters"] = e.target.value
                            } else {
                                copied[measureItr]["dimensionAggregations"][dimItr]["calcType"] = e.target.value
                                copied[measureItr]["dimensionAggregations"][dimItr]["calcParameters"] = ""
                            }
                            
                            setMeasures(copied)
                            fireOnSaveEvent(dbId, dbSystemName, copied)
                            forceUpdate()
                        }}
                        value={getAggregationDropdownValue(measuresData, currentDimension, currentMeasure)}
                        required
                        fullWidth>
                            <MenuItem value={0}>Undefined</MenuItem>
                            <MenuItem value={1}>Sum</MenuItem>
                            <MenuItem value={2}>Count</MenuItem>
                            <MenuItem value={3}>Min</MenuItem>
                            <MenuItem value={4}>Max</MenuItem>
                            <MenuItem value={5}>Average</MenuItem>
                            {weightedAverageMenuItems}
                        </Select>
                </TableCell>)
            }

            tableBodyRows.push(<TableRow key={`measure-row-${currentMeasure["systemName"]}`}>
                <TableCell>{measuresData[measureItr]["measureName"]}</TableCell>
                <TableCell>
                    <TextField
                        fullWidth
                        variant="outlined"
                        value={measuresData[measureItr]["aliasName"]}
                        disabled={false}
                        onChange={(e) => {
                            e.preventDefault()
                            
                            let copied = JSON.parse(JSON.stringify(measuresData))
                            copied[measureItr]["aliasName"] = e.target.value
                            
                            setMeasures(copied)
                            fireOnSaveEvent(dbId, dbSystemName, copied)
                            forceUpdate()
                        }}
                    />
                </TableCell>
                {dimensionAggregationDropDowns}
                <TableCell>
                    <Select
                        id={`measure-format-${measuresData[measureItr]["systemName"]}`}
                        onChange={(e) => {
                            e.preventDefault()
                            let copied = JSON.parse(JSON.stringify(measuresData))
                            copied[measureItr]["format"] = e.target.value
                            setMeasures(copied)
                            fireOnSaveEvent(dbId, dbSystemName, copied)
                            forceUpdate()
                        }}
                        value={measuresData[measureItr]["format"]}
                        required
                        fullWidth>
                            <MenuItem value=""></MenuItem>
                            <MenuItem value="0">0</MenuItem>
                            <MenuItem value="0.0">0.0</MenuItem>
                            <MenuItem value="0.00">0.00</MenuItem>
                            <MenuItem value="#,##0">#,##0</MenuItem>
                            <MenuItem value="#,##0.0">#,##0.0</MenuItem>
                            <MenuItem value="#,##0.00">#,##0.00</MenuItem>
                            <MenuItem value="#,##0;(#,##0)">#,##0;(#,##0)</MenuItem>
                            <MenuItem value="#,##0.00;(#,##0.00)">#,##0.00;(#,##0.00)</MenuItem>
                            <MenuItem value="$#,##0;($#,##0)">$#,##0;($#,##0)</MenuItem>
                            <MenuItem value="$#,##0.00;($#,##0.00)">$#,##0.00;($#,##0.00)</MenuItem>
                            <MenuItem value="0%">0%</MenuItem>
                            <MenuItem value="0.0%">0.0%</MenuItem>
                            <MenuItem value="0.00%">0.00%</MenuItem>
                            <MenuItem value={`0"%"`}>0"%"</MenuItem>
                            <MenuItem value={`0.0"%"`}>0.0"%"</MenuItem>
                            <MenuItem value={`0.00"%"`}>0.00"%"</MenuItem>
                    </Select>
                </TableCell>
                <TableCell>
                    <TextField
                        fullWidth
                        variant="outlined"
                        value={measuresData[measureItr]["formula"]}
                        disabled={editMode}
                        onClick={(e) => {
                            e.preventDefault()
                            setEditFormula(true)
                            setPopupFormula(measuresData[measureItr]["formula"])
                            setPopupSelectedMeasure(measuresData[measureItr]["systemName"])
                        }}
                    />
                </TableCell>
                <TableCell>
                    <IconButton aria-label="delete" onClick={(e) => {
                        e.preventDefault()
                        let copied = JSON.parse(JSON.stringify(measuresData))
                        let rebuilt = []
                        
                        for (let deleteItr = 0; deleteItr < copied.length; deleteItr++) {
                            if (deleteItr !== measureItr) {
                                rebuilt.push(copied[deleteItr])
                            }
                        }
                        setMeasures(rebuilt)
                        fireOnSaveEvent(dbId, dbSystemName, rebuilt)
                        forceUpdate()
                    }}>
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
            </TableRow>)
        }

        return <TableContainer component={Paper}>
            <Table size="small" aria-label="Measure Definitions">
                <TableHead>
                    <TableRow>
                        <TableCell>Member Name</TableCell>
                        <TableCell>Custom Label</TableCell>
                        {dimensionTableHeaders}
                        <TableCell>Format</TableCell>
                        <TableCell>Formula</TableCell>
                        <TableCell>Remove</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{tableBodyRows}</TableBody>
            </Table>
        </TableContainer>
    }
    function getDialogSelections(measuresData, selected) {
        let rtnVal = []

        for (let measureItr = 0; measureItr < measuresData.length; measureItr++) {
            let currentMeasure = measuresData[measureItr]
            if (currentMeasure["systemName"] !== selected) {
                rtnVal.push(<option key={currentMeasure["systemName"]} value={currentMeasure["measureName"]}>
                    {currentMeasure["measureName"]}
                </option>)
            }
        }

        return rtnVal
    }
    //#endregion

    //#region Data Handler Methods
    function getAggregationDropdownValue(measuresData, currentDimension, currentMeasure) {
        for (let measureItr = 0; measureItr < measuresData.length; measureItr++) {
            let measure = measuresData[measureItr]
            if (measure["systemName"] === currentMeasure["systemName"]) {
                for (let dimItr = 0; dimItr < measure["dimensionAggregations"].length; dimItr++) {
                    let currentDimensionAgg = measure["dimensionAggregations"][dimItr]
                    if (currentDimensionAgg["dimensionSystemName"] === currentDimension["systemName"]) {
                        if (currentDimensionAgg["calcType"] === 6) {
                            return currentDimensionAgg["calcParameters"]
                        } else {
                            return currentDimensionAgg["calcType"]
                        }
                    }
                }
            }
        }
        return 0
    }
    function stringIsEmpty(str) { 
        return str.trim() === ''
    }
    //#endregion

    return (<>
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Add Segments</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-databse-label">Select Database</InputLabel>
                <Select
                    labelId="select-databse-label"
                    id="select-databse"
                    label="Select Database"
                    onChange={handleDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
                <Select
                    labelId="select-data-source-label"
                    id="select-data-source"
                    label="Select Data Source"
                    onChange={handleDataSourceChange}
                    value={dataSourceSystemName}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select Data Source</MenuItem>
                        { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>)}
                </Select>
            </FormControl>
            <Box sx={{ width: '100%', bgcolor: 'background.paper', maxHeight: '250px', overflowY: 'scroll', marginTop: '15px' }}>
                {renderMeasureDefinitionTable(dimensions, measures, editFormula, databaseId, dataSourceSystemName)}
            </Box>
            <Button variant="contained" fullWidth disabled={isLoadingRequest || dataSourceSystemName.trim().length === 0} onClick={(e) => {
                e.preventDefault()

                let tempNewMeasureSystemName = `new-measure-${measures.length}`
                let newDimensionAggregations = []
                for (let dimItr = 0; dimItr < dimensions.length; dimItr++) {
                    newDimensionAggregations.push({
                        calcParameters: "",
                        calcType: 0,
                        dimensionSystemName: dimensions[dimItr]["systemName"],
                        measureSystemName: tempNewMeasureSystemName
                    })
                }

                let newMeasure = {
                    aliasName: "",
                    measureName: "",
                    systemName: tempNewMeasureSystemName,
                    format: "",
                    formula: "",
                    dimensionAggregations: newDimensionAggregations
                }

                let copied = JSON.parse(JSON.stringify(measures))
                copied.push(newMeasure)
                setMeasures(copied)
                fireOnSaveEvent(databaseId, dataSourceSystemName, copied)
            }}>Add Another Measure</Button>
        </Paper>
        <Dialog open={editFormula} maxWidth="md">
            <DialogTitle style={{ textAlign: "center" }}>Select Measure Formula</DialogTitle>
            <DialogContent style={{ textAlign: "center" }}>
                <FormControl className="field" fullWidth>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Formula"
                        value={popupFormula}
                        disabled={false}
                        onChange={(e) => {
                            e.preventDefault()
                            setPopupFormula(e.target.value)
                        }}
                    />
                </FormControl>
                <FormControl className="field" fullWidth>
                    <Select
                        multiple
                        value={[]}
                        native
                        onChange={handleChangeMultiple}
                        inputProps={{
                            id: 'select-multiple-native',
                        }}>
                            {getDialogSelections(measures, popupSelectedMeasure)}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions disableSpacing={false} style={{ justifyContent: "center" }}>
            <Button className="btn" variant="contained" disabled={false} onClick={(e) => {
                    e.preventDefault()

                    // Yes you are
                    let copied = JSON.parse(JSON.stringify(measures))
                    for (let measureItr = 0; measureItr < copied.length; measureItr++) {
                        if (copied[measureItr]["systemName"] === popupSelectedMeasure) {
                            copied[measureItr]["formula"] = popupFormula
                        }
                    }

                    fireOnSaveEvent(databaseId, dataSourceSystemName, copied)
                    setMeasures(copied)
                    setEditFormula(false)
                    setPopupFormula('')
                    setPopupSelectedMeasure('')
                }}>
                    Edit
                </Button>
                <Button className="btn" variant="contained" disabled={false} onClick={(e) => {
                    e.preventDefault()
                    setEditFormula(false)
                    setPopupFormula('')
                    setPopupSelectedMeasure('')
                }}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    </>)
}

export default MeasureDefinition